import { Expandable } from 'components/Common/Expandable';
import { formatCurrency, formatDuration } from 'helpers/common';
import renderIcon from 'helpers/renderIcon';
import { IShopServiceTemplateItem, IShopServiceTreeItem } from 'models/shop/serviceTemplates';
import * as React from 'react';

interface IProps {
	items: IShopServiceTreeItem[];
	chosenTemplates?: string[];
	currentServiceCategoryServices?: IShopServiceTemplateItem[];
	groupedServiceGroupsTemplates: any[];
	currencyKey: number;
	t: any;
	inputValue: string;
	handleSelectChosenTemplateClick: (itemId: string) => void;
	handleServiceCategorySelectAll?: () => void;
}

const TemplateReview: React.FC<IProps> = ({
	items,
	chosenTemplates,
	currencyKey,
	handleSelectChosenTemplateClick,
	handleServiceCategorySelectAll,
	t,
	currentServiceCategoryServices,
	groupedServiceGroupsTemplates,
	inputValue,
}) => {
	return (
		<div className="templateReview">
			{items.map((item) => {
				if (!item) {
					return;
				}

				let currentActiveServicesInCategory = 0;
				let currentActiveServiceGroupServices = 0;
				let leftElementIcon: 'checked' | 'unchecked' | 'partially_checked' = 'unchecked';
				let childrenIncludeValue: boolean = false;

				if (item?.type === 'serviceCategory' && currentServiceCategoryServices) {
					for (const cscs of currentServiceCategoryServices) {
						const id = cscs.id.toString();

						if (chosenTemplates.includes(id)) {
							currentActiveServicesInCategory += 1;
						}
					}
				}

				// If statement only when upper service group
				if (item?.level === 0) {
					let allServiceGroupServicesCount = 0;

					// Compare lengths of new array's groups with chosenTemplates props
					groupedServiceGroupsTemplates.map((gsgt) => {
						if (gsgt.parentServiceGroupId === item.parentServiceGroupId) {
							gsgt.items.map((templateItem) => {
								if (chosenTemplates.includes(templateItem.id)) {
									currentActiveServiceGroupServices += 1;
								}

								if (!childrenIncludeValue && templateItem.name.toLowerCase().includes(inputValue.toLowerCase())) {
									childrenIncludeValue = true;
								}

								allServiceGroupServicesCount += 1;
							});
						}
					});

					if (currentActiveServiceGroupServices === allServiceGroupServicesCount) {
						leftElementIcon = 'checked';
					} else if (currentActiveServiceGroupServices > 0) {
						leftElementIcon = 'partially_checked';
					}
				}

				return item?.childrenTemplateItems?.length ? (
					// Skip rendering service category dropdown
					item.type === 'serviceCategory' ? (
						<div key={item.name}>
							<div className="templateReview__category" onClick={() => handleServiceCategorySelectAll()}>
								{currentActiveServicesInCategory === currentServiceCategoryServices.length
									? renderIcon('checked')
									: currentActiveServicesInCategory !== 0
									  ? renderIcon('partially_checked')
									  : renderIcon('unchecked')}
								<span className="templateReview__selectAll">{t('BSPortal_Common_SelectAll')}</span>
								<span className="templateReview__totalServices">{currentServiceCategoryServices?.length}</span>
							</div>

							<TemplateReview
								items={item.childrenTemplateItems}
								handleSelectChosenTemplateClick={(itemId: string) => handleSelectChosenTemplateClick(itemId)}
								currencyKey={currencyKey}
								chosenTemplates={chosenTemplates}
								t={t}
								groupedServiceGroupsTemplates={groupedServiceGroupsTemplates}
								inputValue={inputValue}
							/>
						</div>
					) : // Skip rendering dropdowns for service group and main service
					item.level === 1 || item.level === 2 ? (
						<div key={item.id || item.name}>
							{item.level === 1 && item.childrenTemplateItems.length > 1 ? (
								<div className="templateReview__subserviceGroup">{item.name}</div>
							) : null}{' '}
							{/** Display service group name if it contains multiple services (subservices) */}
							<TemplateReview
								items={item.childrenTemplateItems}
								handleSelectChosenTemplateClick={(itemId: string) => handleSelectChosenTemplateClick(itemId)}
								currencyKey={currencyKey}
								chosenTemplates={chosenTemplates}
								t={t}
								groupedServiceGroupsTemplates={groupedServiceGroupsTemplates}
								inputValue={inputValue}
							/>
						</div>
					) : childrenIncludeValue ? (
						<div key={item.id || item.name}>
							<Expandable
								closed={true}
								title={item.name}
								isArrowIcon={true}
								className="templateReview__serviceGroup"
								leftElement={leftElementIcon}
							>
								<TemplateReview
									items={item.childrenTemplateItems}
									handleSelectChosenTemplateClick={(itemId: string) => handleSelectChosenTemplateClick(itemId)}
									currencyKey={currencyKey}
									chosenTemplates={chosenTemplates}
									t={t}
									groupedServiceGroupsTemplates={groupedServiceGroupsTemplates}
									inputValue={inputValue}
								/>
							</Expandable>
						</div>
					) : null
				) : item.name.toLowerCase().includes(inputValue.toLowerCase()) && !(item as any)?.customData ? (
					<div
						className="templateReview__serviceContainer"
						key={item.id || item.name}
						onClick={() => handleSelectChosenTemplateClick(item.id)}
					>
						<div className="templateReview__serviceSelectName">
							{chosenTemplates?.includes(item.id) ? renderIcon('checked') : renderIcon('unchecked')}
							<span className="templateReview__serviceName">{item.name}</span>
						</div>

						<div className="templateReview__serviceDurationPrice">
							<span className="templateReview__serviceDuration">{formatDuration(item?.duration)}</span>
							<span className="templateReview__servicePrice">{formatCurrency(currencyKey, item?.price)}</span>
						</div>
					</div>
				) : null;
			})}
		</div>
	);
};

export { TemplateReview };
